import request from "@/utils/request";

export function upload(data) {
  return request({
    url: "/consumer/commonLogin/upload",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/uploadFile.js